import { createSlice } from "@reduxjs/toolkit";

const colorSlice = createSlice({
  name: "color",
  initialState: {
    navbar: "",
    body: "",
  },
  reducers: {
    setNavbar: (state, action) => {
      state.navbar = action.payload;
    },
    setBody: (state, action) => {
      state.body = action.payload;
    },
  },
});

export const { setNavbar, setBody } = colorSlice.actions;
export default colorSlice.reducer;
